module.exports = __webpack_public_path__ + "static/media/81.0792f353.png";